import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, CircularProgress, Alert, Link as MuiLink } from '@mui/material'; // Added MuiLink
import ApiService from '../../api/api_service';

const RegisterComponent = ({ onSwitchToLogin }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);


    const handleRegister = async (event) => {
        event.preventDefault();
        setError(null);
        setSuccessMessage('');

        if (!username || !email || !password || !confirmPassword) {
            setError('Please fill in all fields.');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        setLoading(true);

        try {
            const data = await ApiService.register(username, email, password);

            console.log('Registration successful:', data);
            setSuccessMessage(`Registration successful for ${email}! Please log in.`);

            setUsername('');
            setEmail('');
            setPassword('');
            setConfirmPassword('');

            setTimeout(() => {
                if (onSwitchToLogin) {
                    onSwitchToLogin();
                }
            }, 2000);

        } catch (error) {
            setError(error.message || 'Registration failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
            {successMessage && (
                <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>
            )}

            {!successMessage && (
                <form onSubmit={handleRegister}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Register New User</Typography>
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        sx={{ marginBottom: 2 }}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <TextField
                        label="Email"
                        type="email"
                        variant="outlined"
                        fullWidth
                        sx={{ marginBottom: 2 }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        sx={{ marginBottom: 2 }}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <TextField
                        label="Confirm Password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        sx={{ marginBottom: 2 }}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        error={!!error && error.includes('Passwords do not match')}
                    />
                    {error && (
                        <Alert severity="error" sx={{ marginBottom: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Box sx={{ position: 'relative', mt: 1, mb: 2 }}> {/* Added mb */}
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={loading}
                        >
                            Register
                        </Button>
                        {loading && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-12px',
                                    marginLeft: '-12px',
                                }}
                            />
                        )}
                    </Box>
                    <Typography variant="body2">
                        Already have an account?{' '}
                        <MuiLink component="button" variant="body2" onClick={onSwitchToLogin} sx={{ cursor: 'pointer' }}>
                            Login here
                        </MuiLink>
                    </Typography>
                </form>
            )}
        </Box>
    );
};

export default RegisterComponent;
